// MpfInputText.props.ts

import { mpfInputDefaults, MpfInputEmits, MpfInputBaseProps } from '../MpfInput/MpfInputBaseProps';

export interface MpfInputTextProps extends MpfInputBaseProps {
  numbersOnly?: boolean;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfTextInputDefaults = { ...mpfInputDefaults, numbersOnly: false };
export type MpfTextInputEmits = MpfInputEmits;
